import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import ItemsEvents from './ItemsEvents';

import ItemsDetailsSectionInfo from './details/sections/ItemsDetailsSectionInfo';
import ItemsDetailsSectionSecondaryInfo from './details/sections/ItemsDetailsSectionSecondaryInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<ItemsDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_SECONDARY_INFO_SECTION" />
			<ItemsDetailsSectionSecondaryInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="item_descriptionhtml"
				value={props.model.item_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
		</>
	),
	events: ItemsEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
